import { render, staticRenderFns } from "./configBudgets.vue?vue&type=template&id=fc5820d4&scoped=true&"
import script from "./configBudgets.vue?vue&type=script&lang=js&"
export * from "./configBudgets.vue?vue&type=script&lang=js&"
import style0 from "./configBudgets.vue?vue&type=style&index=0&id=fc5820d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5820d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc5820d4')) {
      api.createRecord('fc5820d4', component.options)
    } else {
      api.reload('fc5820d4', component.options)
    }
    module.hot.accept("./configBudgets.vue?vue&type=template&id=fc5820d4&scoped=true&", function () {
      api.rerender('fc5820d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/banquet_management/banquet_reward_configuration/form/components/configBudgets.vue"
export default component.exports